"use client"

import { Switch as SwitchPrimitive } from "@base-ui/react/switch"
import { cn } from "@/primitives/utils"

function Switch({
  className,
  size = "default",
  ...props
}: SwitchPrimitive.Root.Props & {
  size?: "sm" | "default"
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        // beacon: a 28×16 track, the primary when on, with a 2px focus ring. Off, it is an outline
        // in the tertiary text colour rather than the strong-hairline fill spec §7 gave it, which
        // measured 1.4:1 (light) and 1.7:1 (dark) on the panel: a control and its state need 3:1.
        // The outline is a 1px border kept on in both states (primary when on), so the thumb's
        // travel doesn't change. The hit area reaches past the track, 12px each side and 8px above
        // and below on a fine pointer, and to 44px each way on touch (`touch-target`).
        "peer group/switch relative inline-flex shrink-0 items-center rounded-full border p-px transition-colors duration-100 ease-snappy outline-none group-has-[:focus-visible]/field-label:ring-0 after:absolute after:-inset-x-3 after:-inset-y-2 touch-target focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background aria-invalid:ring-2 aria-invalid:ring-destructive/20 data-[size=default]:h-4 data-[size=default]:w-7 data-[size=sm]:h-3.5 data-[size=sm]:w-6 data-checked:border-primary data-checked:bg-primary data-unchecked:border-subtle-foreground data-unchecked:bg-transparent data-disabled:cursor-not-allowed data-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        // beacon: a 12px thumb, near-white and raised on the primary when on, and a flat disc in the
        // tertiary text colour when off, so an off switch never reads as on in either scheme.
        className="pointer-events-none block rounded-full ring-0 transition-[translate,background-color] duration-100 ease-snappy group-data-[size=default]/switch:size-3 group-data-[size=sm]/switch:size-2.5 group-data-[size=default]/switch:data-checked:translate-x-3 group-data-[size=sm]/switch:data-checked:translate-x-2.5 data-unchecked:translate-x-0 data-checked:bg-primary-foreground data-checked:shadow-raised data-unchecked:bg-subtle-foreground"
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
